export default __webpack_public_path__ + "static/media/thumbs-up.1e3ab406.webp";